module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-419.fcf6848e.jpg";